module.exports = __webpack_public_path__ + "img/unknown.d56ce17d.svg";